(ns ui.app-frame
  "`app-frame` will surround your UI with the sidebar and the navbar."
  (:require [storrito.calendly.links :as calendly]
            [storrito.ui.core :as ui]
            [ui.navbar :as navbar]
            [ui.sidebar :as sidebar]
            [ui.user-session :as user-session]
            [parts.replicant.query :as query]))

(def user-session-query
  {:query/kind :query/user-session})

(defn book-call-button
  "Floating phone button next to the Crisp chat bubble (bottom-right).
   Hidden on phone-sized screens, where it would crowd the Crisp bubble
   and cover too much content. `org-uuid` goes into the booking link so
   the call can be joined to the organization."
  [org-uuid]
  [:a.fixed.bottom-5.right-24.z-50.h-12.w-12.rounded-full.bg-blue-600.text-white.hidden.sm:flex.items-center.justify-center.shadow-lg.hover:bg-blue-700.transition-colors
   {:href (calendly/url :solutions "phone-button" org-uuid)
    :target "_blank"
    :title "Book a call"
    :aria-label "Book a call"}
   [:i.fas.fa-phone]])

(defn app-frame
  [state content & [{:keys [secondary-sidebar]}]]
  (if (query/loading? state user-session-query)
    [:div "loading..."]
    [:div.flex.flex-col.h-full
     (navbar/navbar state)
     [:main.flex-1.overflow-auto
      [:div.flex.flex-col.h-full
       [:div.flex.p-0.overflow-hidden.relative.grow
        (sidebar/sidebar-toggle state)
        (when-not (:ui/hide-side-menu? state)
          (sidebar/sidebar state))
        secondary-sidebar
        [:div.overflow-y-auto.grow.bg-gray-100
         [:div.flex.flex-auto.flex-col.p-3.sm:p-5
          {:class ui/container}
          content]]]]]
     ;; bare pages like connect3 hide the side menu and carry their own
     ;; call CTA — one call CTA per screen
     (when-not (:ui/hide-side-menu? state)
       (book-call-button (user-session/org-uuid state)))]))
